// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__TX9ur","textBlock":"styles_textBlock__JcHpy","title":"styles_title__eAY24"};